import { FC } from 'react';

import { CorporateDetails } from '@/api/corporate/corporate.types.ts';
import CorporateDetailsGrid from '@/components/layout/corporateDashboard/CorporateDetailsGrid.tsx';

type CorporateDetailsModalProps = {
  isOpen: boolean;
  onClose: () => void;
  details: CorporateDetails;
};

const CorporateDetailsModal: FC<CorporateDetailsModalProps> = ({
  isOpen,
  onClose,
  details,
}: CorporateDetailsModalProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="relative bg-white rounded-2xl shadow-lg p-6 w-[calc(100%-2rem)] sm:w-full max-w-lg max-h-[90vh] overflow-y-auto">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-honoursOrange text-xl cursor-pointer"
          type="button"
          aria-label="Close"
        >
          <i className="pi pi-times" />
        </button>

        <div className="text-h4 mb-3 text-black font-semibold flex items-center py-2">
          <span>View Corporate User Details</span>
        </div>

        <CorporateDetailsGrid corporateDetails={details} />
      </div>
    </div>
  );
};

export default CorporateDetailsModal;
